module.exports = __webpack_public_path__ + "img/rectarea.65696080.svg";